// @flow
import {Typography, makeStyles} from '@material-ui/core';
import React from 'react';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';

import productImg from '../../../../assets/img/onboarding/see-store-step.png';
import {getCustomDomain} from '../../../../utils/component';
import {useStoreInfo} from '../../../store/utils';
import {useIsMobile} from '../../../../utils/dom';

type Props = {
  setPageDisplayed: (v: boolean) => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.5),
    backgroundColor: 'white',
    borderRadius: 8,
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      gap: '12px',
    },
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: 12,
  },
  subtitle: {
    fontSize: 12,
  },
  button: {
    marginTop: theme.spacing(2),
    borderRadius: 8,
  },
  imgWrap: {
    maxWidth: 150,
  },
  img: {
    maxWidth: '100%',
  },
}));
const SeeStoreStep = ({setPageDisplayed}: Props) => {
  const classes = useStyles();
  const store = useStoreInfo();

  const mobile = useIsMobile();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div>
          <Typography className={classes.title} gutterBottom>
            Ve tu tienda por primera vez
          </Typography>

          <Typography className={classes.subtitle} gutterBottom>
            Mira como va quedando tu tienda virtual
          </Typography>

          <CustomButton
            fullWidth={mobile}
            variant="contained"
            className={classes.button}
            href={`https://${getCustomDomain(store)}`}
            onClick={() => setPageDisplayed(true)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver Tienda
          </CustomButton>
        </div>

        <div className={classes.imgWrap}>
          <img src={productImg} className={classes.img} alt="" />
        </div>
      </div>
    </div>
  );
};

export default SeeStoreStep;
